import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  HttpClient, HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';



@Injectable({
  providedIn: `root`,
})
export class ApiService {

  // private apiRoot: string;
  // public results: any[];
  // public path: string;
  // public loading: boolean;
  // public appId: string;
  /// * discuss and refactor this class */
  //const c = new CookieService();
  //constructor(private cookieService: CookieService) {  
  // }

  //#region static Api Helper

  //private static httpOptions = {
  //  headers: new HttpHeaders({
  //    'Content-Type': 'application/json',

  //  }), withCredentials: true
  //};

  public static genericObservablePost = (
    http: HttpClient,
    apiEndPoint: string,
    data: any
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;
    const token = localStorage.getItem('aap_user_token');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), withCredentials: true
    };
    if (token) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }), withCredentials: true
      };
    }
    return http.post(apiURL, data, httpOptions) as Observable<any>;
  }

  public static genericObservablerynoGet = (
    http: HttpClient,
    apiEndPoint: string,
  ) => {
    const apiURL = environment.rynohubapiUrl + apiEndPoint;
    const token = localStorage.getItem('aap_user_token');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), withCredentials: true
    };
    if (token) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }), withCredentials: true
      };
    }
    return http.get(apiURL, httpOptions) as Observable<any>;
  }
  public static genericObservableGet = (
    http: HttpClient,
    apiEndPoint: string,
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;
    const token = localStorage.getItem('aap_user_token');
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), withCredentials: true
    };
    if (token) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }), withCredentials: true
      };
    }
    return http.get(apiURL, httpOptions) as Observable<any>;
  }

  
  //todo: Temp Soln. Need to remove
  public static genericJSONGet = (
    http: HttpClient,
  ) => {

    return http.get("./assets/masterdata.json") as Observable<any>;
  }


  public static genericObservablePostFormData = (
    http: HttpClient,
    apiEndPoint: string,
    data: any, formData: any
  ) => {
    const apiURL = environment.apiUrl + apiEndPoint;

    return http.post(apiURL, formData, { params: data }) as Observable<any>;
  }
  //#endregion


}
